import { useState } from 'react'
import { createPortal } from 'react-dom'
import { Button } from '@diwata/ironvale'
import { AssaySDK } from '@diwata-labs/assay-sdk'

// Feedback files straight into Assay — the Diwata ticketing desk. The SDK grabs a
// screenshot + page metadata alongside your words, so a report arrives reproducible.
// Renders nothing unless the build carries the Assay endpoint + intake key.

const ENDPOINT = import.meta.env.VITE_ASSAY_ENDPOINT as string | undefined
const KEY = import.meta.env.VITE_ASSAY_KEY as string | undefined

export function Feedback() {
  const [open, setOpen] = useState(false)
  const [comment, setComment] = useState('')
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState<string | null>(null)

  if (!ENDPOINT || !KEY) return null

  async function send() {
    if (!comment.trim() || busy) return
    setBusy(true)
    try {
      const sdk = new AssaySDK({ apiKey: KEY!, endpoint: ENDPOINT! })
      await sdk.capture({ comment: comment.trim(), kind: 'report' })
      setDone('Filed to Assay — the Diwata ticketing desk. Thank you.')
      setComment('')
      setTimeout(() => {
        setDone(null)
        setOpen(false)
      }, 2500)
    } catch {
      setDone('Could not file that. Try again in a moment.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <button type="button" className="iv-nav-item dw-feedback-btn" onClick={() => setOpen(true)}>
        Feedback
      </button>
      {open &&
        createPortal(
          <>
            <div className="dw-scrim dw-scrim--feedback" onClick={() => setOpen(false)} />
            <div className="dw-feedback-pop dw-panel" role="dialog" aria-label="Feedback">
          <div className="dw-rail-section-title">Feedback → Assay</div>
          <p className="dw-notice" style={{ marginBottom: 8 }}>
            Goes straight to the Diwata ticketing desk, with a screenshot of this page.
          </p>
          <textarea
            className="dw-input dw-textarea"
            rows={3}
            placeholder="What broke, or what should exist?"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          {done && <div className="dw-notice" style={{ marginTop: 6 }}>{done}</div>}
          <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
            <Button size="sm" variant="primary" disabled={busy || !comment.trim()} onClick={send}>
              {busy ? 'Filing…' : 'File it'}
            </Button>
            <Button size="sm" variant="ghost" onClick={() => setOpen(false)}>
              Close
            </Button>
          </div>
            </div>
          </>,
          document.body,
        )}
    </>
  )
}
